import React from 'react';

import Col from 'react-bootstrap/Col';
import EditorSaveScheduleCancel from '../shared/buttons/EditorSaveScheduleCancel';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import permissionsProvider from '../../utilities/permissionsProvider';

const EditForm = ({
    cancelEdit,
    form: { formChange },
    form: { item },
    submitForm,
    schedule
}) => {
    const disabled = !permissionsProvider.canEdit(item.acl);

    return (
        <div>
            <div className="item-editor">
                <Row className="justify-content-end">
                    <Col xs="auto" className="fields-required-label"/>
                </Row>
                <Form.Row>
                    <Col sm={6}>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.dateCalledIn}
                                    name="dateCalledIn"
                                    onChange={formChange}
                                    placeholder="Date Called In"
                                    type="date"
                                    validationError={item.dateCalledIn_error}
                                    disabled={disabled}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.addressLine1}
                                    name="addressLine1"
                                    onChange={formChange}
                                    placeholder="Address Line 1"
                                    required
                                    validationError={item.addressLine1_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.addressLine2}
                                    name="addressLine2"
                                    onChange={formChange}
                                    placeholder="Address Line 2"
                                    validationError={item.addressLine2_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md>
                                <FormControl
                                    required
                                    defaultValue={item.city}
                                    validationError={item.city_error}
                                    name="city"
                                    onChange={formChange}
                                    placeholder="City"
                                    disabled={disabled} />
                            </Form.Group>
                            <Form.Group as={Col} xs="auto" style={{ maxWidth: "75px" }}>
                                <SelectList
                                    required={true}
                                    placeholder="State"
                                    name="stateId"
                                    value={item.stateId}
                                    validationError={item.stateId_error}
                                    lookupType="State"
                                    onChange={formChange}
                                    disabled={disabled} />
                            </Form.Group>
                            <Form.Group as={Col} xs md={4}>
                                <FormControl
                                    defaultValue={item.zip}
                                    name="zip"
                                    onChange={formChange}
                                    placeholder="Zip"
                                    required
                                    validationError={item.zip_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                    </Col>
                    <Form.Group as={Col} sm={6}>
                        <FormControl
                            as="textarea"
                            className="form-control"
                            defaultValue={item.description}
                            name="description"
                            onChange={formChange}
                            placeholder="Description"
                            required
                            rows="6"
                            validationError={item.description_error}
                            disabled={disabled}/>
                    </Form.Group>
                </Form.Row>
            </div>
            <EditorSaveScheduleCancel
                middleButtonAction={() => schedule({ item: { id: item.id } })}
                middleButtonImg="/images/schedule.svg"
                reschedule={item.appointmentDate}
                scheduleAction={() => submitForm(schedule)}
                save={item.appointmentDate ? submitForm : () => submitForm(schedule)}
                cancel={cancelEdit}
                acl={item.acl}
                appointmentId={item.appointmentId}
                appointmentType={3}/>
        </div>
    );
}

export default EditForm;